module.exports = __webpack_public_path__ + "static/img/13.b357c62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/13.png
// module id = 9h0r
// module chunks = 0